module.exports = __webpack_public_path__ + "img/kenbi01.149e58ed.jpg";